<template>
    <div>
        <div class="m-portlet left select" :style="{'height': clientHeight-150+'px'}">
            <div class="m-portlet__head">
                <div class="m-portlet__head-caption" style="width: 100%">
                    <div class="m-portlet__head-title" style="width: 100%">
                        <h5>筛选条件</h5>
                    </div>
                </div>
            </div>
            <div class="m-portlet__body ">
                <el-form label-position="top">
                    <el-form-item label="筛选学校">
                        <el-select v-model="school" clearable placeholder="请选择学校" filterable remote
                                   :remote-method="handleSearchSchool" @change="handleChange()">
                            <el-option
                                    v-for="item in schools"
                                    :key="item.id"
                                    :label="item.name"
                                    :value="item.id">
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="筛选年级">
                        <el-select v-model="grade" clearable placeholder="请选择年级" @change="handleChange()">
                            <el-option
                                    v-for="item in grades"
                                    :key="item.id"
                                    :label="item.name"
                                    :value="item.id">
                            </el-option>
                        </el-select>
                    </el-form-item>

                    <el-form-item label="筛选学生">
                        <el-select v-model="student_id" clearable placeholder="请选择学生"
                                   filterable remote
                                   :remote-method="handleSearchStudent"
                                   @change="handleChange()">
                            <el-option
                                    v-for="item in choose_student"
                                    :key="item.id"
                                    :label="item.name"
                                    :value="item.id">
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="筛选班主任">
                        <el-select v-model="headTeacher" clearable placeholder="请选择班主任" filterable remote
                                   :remote-method="handleSearchHeadTeacher" @change="handleChange()">
                            <el-option
                                    v-for="item in headTeachers"
                                    :key="item.id"
                                    :label="item.name"
                                    :value="item.id">
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="筛选学期有课学生">
                        <el-select v-model="semester" placeholder="请选择学期" @change="handleChange()">
                            <el-option
                                    v-for="item in semesters"
                                    :key="item.id"
                                    :label="item.name"
                                    :value="item.id">
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="筛选是否有班主任的学生">
                        <el-select v-model="hasHeadTeacherStudent" clearable placeholder="请选择是否有班主任的学生"
                                   @change="handleChange()">
                            <el-option
                                    v-for="item in hasHeadTeacherStudents"
                                    :key="item.value"
                                    :label="item.label"
                                    :value="item.value">
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="筛选时间">
                        <el-select v-model="template_day_ids" clearable multiple placeholder="请选择时间"
                                   @change="handleChange()">
                            <el-option
                                    v-for="item in template_days"
                                    :key="item.id"
                                    :label="item.name"
                                    :value="item.id">
                            </el-option>
                        </el-select>
                    </el-form-item>
                </el-form>
            </div>
        </div>
        <div class="m-portlet right">
            <div class="m-portlet__body">
                <table class="table table-striped" v-loading="loading">
                    <thead>
                    <tr>
                        <th>学号</th>
                        <th>姓名</th>
                        <th>学校</th>
                        <th>年级</th>
                        <th>学生联系方式</th>
                        <th>家长姓名</th>
                        <th>家长联系方式</th>
                        <th>班主任</th>
                        <!--<th>获取次数</th>-->
                        <th>操作</th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr v-for="item in students" :key="item.id">
                        <td>{{item.id}}</td>
                        <td>{{item.name}}</td>
                        <td v-if="item.current_education">{{item.current_education.school.name}}</td>
                        <td v-else>学校未添加</td>
                        <td v-if="item.current_education">{{item.current_education.grade.name}}</td>
                        <td v-else>年级未添加</td>
                        <td>{{item.phone}}</td>
                        <td>
                            <p v-for="parent in item.parents" :key="parent.id">
                                <span>{{parent.parent_identity}}： {{parent.name}}</span>
                            </p>
                        </td>
                        <td>
                            <p v-for="parent in item.parents" :key="parent.id">
                                <span>手机: +86 {{parent.phone}}</span>
                            </p>
                        </td>
                        <td><span v-for="(headTeacher,index) in item.headTeachers"
                                  :key="index"> {{headTeacher.name}} </span></td>
                        <!--<td >{{item.courseNotify}}</td>-->
                        <td>
                            <el-button size="mini" @click="handleCopyCourseNotify(item.id)">获取课程信息</el-button>
                        </td>
                    </tr>
                    </tbody>
                </table>
                <!--分页-->
                <div class="text-center m-t-10">
                    <el-pagination
                            @size-change="handleSizeChange"
                            @current-change="handleCurrentChange"
                            :current-page="currentPage"
                            :page-sizes="[10, 20, 50, 100]"
                            :page-size="10"
                            layout="total, sizes, prev, pager, next, jumper"
                            :total="total">
                    </el-pagination>
                </div>
            </div>
        </div>
        <input ref="copyme" v-model="copeData" type="text" style="opacity: 0;"/>
    </div>

</template>

<script>
    import store from '@/store'
    // import Clipboard from 'clipboard';

    export default {
        name: "students-list",
        data() {
            return {
                path: "/student/courseNotify/list",
                copeData: '',
                notify_temp: '',
                semester: '',
                semesters: [],
                headTeachers: [],
                schools: [],
                grades: [],
                haveStudents: [],
                choose_student:[],
                student_id:'',
                student: '',
                grade: '',
                school: '',
                headTeacher: '',
                confirmStudent: '',
                courseConfirmStudent: '',
                nowSemester: [],
                headTeacher_student: '',
                notHeadTeacher_student: '',
                haveClass_student: '',
                noHeadTeacher_student: '',
                confirm_student: '',
                haveHeadTeacher_student: '',
                studentKeyName: '',
                activeNames: ['1'],
                loading: true,
                students: [],
                total: 0,
                currentPage: 1,
                currentPageSize: 10,
                check_1: '',
                hasHeadTeacherStudent: '',
                hasHeadTeacherStudents: [{
                    value: '1',
                    label: '有班主任的学生'
                }, {
                    value: '0',
                    label: '没有班主任的学生'
                }],
                confirmStudents: [{
                    value: '1',
                    label: '已通知的学生'
                }, {
                    value: '0',
                    label: '未通知的学生'
                }],
                courseConfirmStudents: [{
                    value: '1',
                    label: '已通知的学生'
                }, {
                    value: '0',
                    label: '未通知的学生'
                }],
                template_day_ids: [],
                template_days: [],
            }
        },
        props: {},
        components: {},
        mounted() {
            this.$nextTick(() => {
            })
        },
        created() {
            this.nowSemester = this.$store.state.config.nowSemester;
            this.semester = this.nowSemester.id;
            this.handleCreate();
            this.handleSearchSchool("");
            this.handleSearchStudent("");
            this.handleSearchHeadTeacher("");
            this.handleSearchTemplateDay(this.nowSemester.id);
        },
        computed: {
            clientHeight() {
                return this.$store.state.config.clientHeight;
            },
            powers() {
                return this.$store.state.config.powers;
            },
            right_level() {
                return this.$store.state.user.employee.right_level;
            },
            orderStudents: function () {
                return this._.orderBy(this.students, 'id', 'desc');
            },
        },
        methods: {
            handleCopyCourseNotify(student_id) {
                // this.$axios.get(store.state.server + '/student/list/courseNotify?student_id=' + student_id + '&' + localStorage.baseUrl).then((response) => {
                //     if (response.data.status == 'success') {
                //         this.copeData = response.data.data;
                //
                //         setTimeout(() => {
                //             this.$refs['copyme'].select();
                //             document.execCommand('copy');
                //             this.$notify({
                //                 title: '成功',
                //                 message: '复制成功',
                //                 type: 'success'
                //             });
                //
                //         }, 100)
                //
                //     }
                // })
                this.$wApi.send(this.path, 'courseNotify', {
                    'student_id': student_id,
                });
            },
            courseStatusSure(student_id) {
                this.$confirm('确认先前课程变动已发送学生?', '提示', {
                    StartReturn: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    this.$axios.get(store.state.server + '/student/list/courseStatusSure?student_id=' + student_id + '&' + localStorage.baseUrl).then((response) => {
                        if (response.data.status == 'success') {
                            this.$notify({
                                title: '成功',
                                message: '确认成功',
                                type: 'success'
                            });
                        }
                    })
                }).catch(() => {
                    this.$message({
                        type: 'info',
                        message: '已取消'
                    });
                });
            },
            handleSearchSchool(query) {
                this.$wApi.send(this.path, 'search_school', {
                    'schoolKeyName': query
                });
            },
            handleSearchStudent(query){
                this.$wApi.send(this.path, 'search_student', {
                    'studentKeyName': query
                });
            },
            handleSearchHeadTeacher(query) {
                this.$wApi.send(this.path, 'search_headTeacher', {
                    'headTeacherKeyName': query
                });
            },
            changeStudents() {
                const student = this.student;
                this.loading = true;
                this.handleIndexStudent(student);
            },
            handleSearchTemplateDay(semester_id) {
                this.$wApi.send(this.path, 'search_templateDay', {
                    'semester_id': semester_id
                });
            },
            changeSemester() {
                this.loading = true;
                this.handleSearchTemplateDay(this.semester)
                this.handleChange();
            },
            handleCreate() {
                this.$wApi.addListen(this.path, this.handleData);
                this.$wApi.send(this.path, 'init', {});
                this.handleChange();
            },
            handleData(event, data) {
                switch (event) {
                    case 'search_school':
                        this.schools = data['schools'];
                        break;
                    case 'search_student':
                        this.choose_student = data.choose_student;
                        break;
                    case 'search_headTeacher':
                        this.headTeachers = data.headTeachers;
                        break;
                    case 'search_templateDay':
                        this.template_days = data.template_days;
                        break;
                    case 'init':
                        this.grades = data['grades'];
                        this.semesters = data['semesters'];
                        break;
                    case 'index':
                        this.students = data['students'];
                        this.total = data['total'];
                        this.loading = false;
                        break;
                    case 'courseNotify':
                        // this.copeData = data['courseNotify'];
                        // setTimeout(() => {
                        //     this.$refs['copyme'].select();
                        //     document.execCommand('copy');
                        //     this.$notify({
                        //         title: '成功',
                        //         message: '复制成功',
                        //         type: 'success'
                        //     });
                        //
                        // }, 100)
                        this.copyToClipboard(data['courseNotify']);
                        break;
                }
            },
            success(id, status) {
                this.$axios.put(store.state.server + '/student/list/' + id + '?' + localStorage.baseUrl
                    , {'status': status}
                ).then(response => {
                    if (response.data.status == 'success') {
                        this.handleIndexStudent(this.currentPage, 10);
                    }
                })
            },
            handleChange() {
                this.loading = true;
                this.$wApi.send(this.path, 'index', {
                    'pageSize': this.currentPageSize,
                    'page': this.currentPage,
                    'school_id': this.school,
                    'semester_id': this.semester,
                    'grade_id': this.grade,
                    'employee_id': this.headTeacher,
                    'template_day_ids': this.template_day_ids,
                    'have_headTeacher': this.hasHeadTeacherStudent,
                    'student_id':this.student_id
                });
            },

            copyToClipboard(text) {
                // if(text.indexOf('-') !== -1) {
                //     let arr = text.split('-');
                //     text = arr[0] + arr[1];
                // }
                var textArea = document.createElement("textarea");
                textArea.style.position = 'fixed';
                textArea.style.top = '0';
                textArea.style.left = '0';
                textArea.style.width = '2em';
                textArea.style.height = '10em';
                textArea.style.padding = '0';
                textArea.style.border = 'none';
                textArea.style.outline = 'none';
                textArea.style.boxShadow = 'none';
                textArea.style.background = 'transparent';
                textArea.value = text;
                document.body.appendChild(textArea);
                textArea.select();
                try {
                    var successful = document.execCommand('copy');
                    var msg = successful ? '成功复制到剪贴板' : '该浏览器不支持点击复制到剪贴板';
                    this.$message({
                        type: 'success',
                        message:msg
                    });
                } catch (err) {
                    this.$message({
                        type: 'success',
                        message:'该浏览器不支持点击复制到剪贴板'
                    });
                }
                document.body.removeChild(textArea);
            },

            handleStudentTicket(id, employee_id) {
                this.$axios.post(store.state.server + '/home/homeNotify?student_id=' + id + '&employee_id=' + employee_id + '&' + localStorage.baseUrl).then((response) => {
                    if (response.data.status == 'success') {
                        this.$notify({
                            title: '成功',
                            message: '开票申请成功',
                            type: 'success'
                        });
                    }
                })
            },
            handleListListen() {
                this.$Echo.private('studentList')
                    .listen('.headTeacherNameUpdate', (e) => {
                        for (var p in this.students) {
                            if ((e.student_id.indexOf(Number(p))) != -1) {
                                this.students[p].headTeacher.name = e.headTeacherName;
                            }
                        }
                    }).listen('.studentInformationDestroy', (e) => {
                    for (var p in this.students) {
                        if (p == e.student.id) {
                            this.handleIndexStudent(this.currentPage, this.currentPageSize);
                        }
                    }
                }).listen('.studentInformationStore', (e) => {
                    var length = 0;
                    for (var p in this.students) {
                        length++;
                    }
                    if (length < 10) {
                        if (length === 0) {
                            this.students.push(e.student)
                        } else {
                            this.$set(this.students, e.student.id, e.student);
                        }
                    }
                }).listen('.studentInformationListUpdate', (e) => {
                    for (var p in this.students) {
                        if (p == e.student.id) {
                            this.students[p] = e.student;
                        }
                    }
                });
            },
            handleIndexStudent() {
                const currentPage = this.currentPage;
                const currentPageSize = this.currentPageSize;
                this.$axios.get(store.state.server + '/student/list?currentPage=' + currentPage + '&currentPageSize=' + currentPageSize + '&isHeadTeacherStudent=' + this.isHeadTeacherStudent + '&hasHeadTeacherStudent=' + this.hasHeadTeacherStudent
                    + '&confirm_student=' + this.confirm_student + '&headTeacher=' + this.headTeacher + '&school=' + this.school + '&grade=' + this.grade + '&confirmStudent=' + this.confirmStudent + '&courseConfirmStudent=' + this.courseConfirmStudent
                    + '&semester=' + this.semester + '&' + localStorage.baseUrl + '&student=' + this.student + '&nowSemester=' + this.nowSemester.id).then(response => {
                    if (response.data.status == 'success') {
                        if (Object.keys(response.data.data.students).length > 0) {
                            this.students = response.data.data.students;
                        } else {
                            this.students = new Object();
                        }
                        this.total = response.data.data.total;
                        this.loading = false;
                    }
                })
            },
            handleStudentInformation(student_id, title) {
                this.$store.dispatch('addView', {
                    'title': title,
                    'path': '/student/' + student_id,
                    'closable': true
                });
                this.router.push({path: '/student/' + student_id})
            },
            handleSizeChange(val) {
                this.currentPageSize = val;
                this.loading = true;
                this.handleChange();
            },
            handleCurrentChange(val) {
                this.currentPage = val;
                this.loading = true;
                this.handleChange();
            },
            onCopy() {
                this.$notify({
                    title: '复制成功',
                    message: '内容已复制至剪切板',
                    type: 'success'
                });
            },
            onError() {
                this.$notify({
                    title: '复制失败',
                    message: '请联系程序员',
                    type: 'error'
                });
            },
        }
    }
</script>

<style scoped lang="scss">
    .left {
        float: left;
        width: 220px;
    }

    .right {
        margin-left: 225px;
    }

    .select{
        &::-webkit-scrollbar {
            width: 0px;
            height: 0px;
        }
        position: absolute;
        overflow: auto;
    }
</style>
